import { render, staticRenderFns } from "./RentsPerUserReportList.vue?vue&type=template&id=90b1c2f6"
import script from "./RentsPerUserReportList.vue?vue&type=script&lang=js"
export * from "./RentsPerUserReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports